module.exports = __webpack_public_path__ + "static/img/guest1.2dd4742.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest1.png
// module id = gO5R
// module chunks = 0